<template>
  <transition name="fade">
    <div v-if="visible" class="saving-overlay">
      <div class="saving-box">
        <Loader width="36px" height="36px" />
        <p class="saving-text">Sauvegarde en cours…</p>
        <p class="saving-subtext">Nous régénérons vos menus pour prendre en compte vos nouvelles préférences.</p>
      </div>
    </div>
  </transition>
</template>

<script>
import Loader from "@/components/Loader.vue";
import { userState } from "@/utils/store";

export default {
  name: "GlobalSavingOverlay",
  components: { Loader },
  computed: {
    visible() {
      return userState.globalSaving;
    },
  },
};
</script>

<style scoped>
.saving-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
}

.saving-box {
  background: #fff;
  border-radius: 12px;
  padding: 36px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

.saving-text {
  font-size: 17px;
  font-weight: 600;
  color: #2f3e46;
  margin: 0;
}

.saving-subtext {
  font-size: 13px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
